import React, { Component } from 'react';

class ChapterSectionLoader extends Component {
  shouldDisplay() {
    return this.props.sectionIndex <= this.props.currentIndex + 2;
  }
  render() {
    return React.cloneElement(this.props.children, {
      display: this.shouldDisplay(),
    });
  }
}

export default ChapterSectionLoader;



// WEBPACK FOOTER //
// ./src/components/chapter/ChapterSectionLoader.js